import { Staff } from '@affdice/portal-kit';

import { PlatformApi } from '../../client.ts';

/**
 * The platform's own people. An operator's team is theirs to manage; this is
 * the kit's shared team screen scoped to the platform.
 */
export function Users({ api, canWrite, userId }: { api: PlatformApi; canWrite: boolean; userId?: string | undefined }) {
  return <Staff api={api} scope="platform" canWrite={canWrite} {...(userId ? { currentUserId: userId } : {})} />;
}
